const getPreviewBaseUrl = (previewDomain) => {
    const value = typeof previewDomain === 'string' ? previewDomain.trim() : '';
    if (!value) return null;

    const candidate = /^[a-z][a-z\d+.-]*:\/\//i.test(value)
        ? value
        : `${location.protocol}//${value}`;

    try {
        const url = new URL(candidate);
        if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) return null;
        return candidate;
    } catch {
        return null;
    }
};

export default getPreviewBaseUrl;
